import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "intelligence-dashboards",
  "use": "intelligence-dashboards-usage",
  "viewBox": "0 0 61 60",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 61 60\" id=\"intelligence-dashboards\"><path clip-rule=\"evenodd\" d=\"M26.75 31.315a2.445 2.445 0 01-2.438 2.45h-19.5a2.443 2.443 0 01-2.437-2.45V4.34a2.445 2.445 0 012.44-2.45l19.5.032a2.445 2.445 0 012.435 2.45v26.943zM58.615 16.36a2.422 2.422 0 01-2.438 2.405h-19.5a2.42 2.42 0 01-2.437-2.405V4.327a2.42 2.42 0 012.432-2.405l19.5-.032a2.425 2.425 0 012.443 2.405V16.36zM26.75 55.727a2.428 2.428 0 01-2.442 2.413l-19.5-.032a2.423 2.423 0 01-2.433-2.41V43.674a2.422 2.422 0 012.438-2.41h19.5a2.425 2.425 0 012.437 2.41v12.053zM36.68 58.14a2.445 2.445 0 01-2.44-2.453v-26.97a2.445 2.445 0 012.438-2.452h19.5a2.444 2.444 0 012.437 2.453v26.937a2.447 2.447 0 01-2.435 2.453l-19.5.032z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/intelligence-dashboards.svg
// module id = Q6IH
// module chunks = 38 43